import { useState, useRef, useEffect, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { motion, AnimatePresence } from "framer-motion";
import ProgressBar from "../Components/ProgressBar";
import axios from 'axios';
import './CopyCustomerPage.css';


const getCustomer = process.env.REACT_APP_GET_CUSTOMER;
const accountCopy = process.env.REACT_APP_ACCOUNT_COPY;

const greeting = () => {
  const currentHour = new Date().getHours();
  if (currentHour < 12) {
    return "Good Morning";
  } else if (currentHour < 18) {
    return "Good Afternoon";
  } else {
    return "Good Evening";
  }
};

const states = (process.env.REACT_APP_STATES)
  .split(",")
  .map((entry) => {
    const [abbr, name] = entry.split(":");
    return { value: abbr, label: name };
  });


const CopyCustomerPage = () => {

  const { accounts } = useMsal();
  const userEmail = accounts[0]?.username;

  const navigate = useNavigate();

  const [customer, setCustomer] = useState({
    CustomerCode: '',
    ShippingLastName: '',
    TaxCode: '',
    BranchCode: '',
    Territory: '',
    ShippingAddressLine1: '',
    ShippingAddressLine2: '',
    CollateFormEmailOverride: '',
    ShippingCity: '',
    ShippingState: '',
    ShippingZip: ''
  });
  const [newCustomer, setNewCustomer] = useState({
    CustomerCode: '',
    TaxCode: '',
    BranchCode: '',
    Territory: '',
    ShippingAddressLine1: '',
    ShippingAddressLine2: '',
    CollateFormEmailOverride: '',
    ShippingCity: '',
    ShippingState: '',
    ShippingZip: ''
  });
  const [territoryCodes, setTerritoryCodes] = useState([]);
  const [branchCodes, setBranchCodes] = useState([]);
  const [customerCodeRequest, setCustomerCodeRequest] = useState('');
  const [taxCodes, setTaxCodes] = useState([]);
  const [openUp, setOpenUp] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [retrieveProgress, setRetrieveProgress] = useState(0);
  const [isCheckLoading, setIsCheckLoading] = useState(false);
  const [isRetrieveLoading, setIsRetrieveLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const progressRef = useRef(null);

  const [isReviewing, setIsReviewing] = useState(false);
  const [toast, setToast] = useState({ type: '', message: '' });

  const CustomSelect = ({ label, value, onChange, options, minWidth }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
      if (isOpen && containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;

        // if not enough space below but enough above → open upwards
        if (spaceBelow < 200 && spaceAbove > spaceBelow) {
          setOpenUp(true);
        } else {
          setOpenUp(false);
        }
      }
    }, [isOpen]);

    return (
      <div
        className={`select-container`}
        style={{
          opacity: 1,
          pointerEvents: "auto",
          textAlign: "left",
          minWidth: minWidth || "250px"
        }}
        ref={containerRef}
      >
        <label style={{ fontWeight: "bold", marginBottom: "5px" }}>{label}</label>
        <div
          className="select-display"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {options.find((opt) => opt.value === value)?.label || "Select"}
          <span style={{ color: isOpen ? "black" : "gray" }}>{isOpen ? "▲" : "▼"}</span>
        </div>

        <AnimatePresence>
          {isOpen && (
            <motion.ul
              className={`options-list ${openUp ? 'up' : ''}`}
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              {options.map((option) => (
                <li
                  key={option.value}
                  className="select-option"
                  onClick={() => {
                    onChange(option.value);
                    setIsOpen(false);
                  }}
                >
                  {option.label}
                </li>
              ))}
            </motion.ul>
          )}
        </AnimatePresence>
      </div>
    );
  };

  const TaxCodeSelect = ({ value, onChange, taxCodes = [] }) => {
    const [query, setQuery] = useState(value || "");
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
      setQuery(value || "");
    }, [value]);

    const filteredCodes = useMemo(() => {
      if (query.length < 2) return [];
      return (taxCodes || []).filter((code) =>
        code.value.toLowerCase().includes(query.toLowerCase()) ||
        code.label.toLowerCase().includes(query.toLowerCase())
      );
    }, [query, taxCodes]);

    useEffect(() => {
      if (isOpen && containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;

        // if not enough space below but enough above → open upwards
        if (spaceBelow < 200 && spaceAbove > spaceBelow) {
          setOpenUp(true);
        } else {
          setOpenUp(false);
        }
      }
    }, [isOpen]);

    const containerRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
      <div
        className={`select-container`}
        style={{
          opacity: 1,
          pointerEvents: "auto",
          textAlign: "left",
          width: "270px",
        }}
        ref={containerRef}
      >
        <input
          type="text"
          value={query}
          placeholder="Start Typing..."
          onChange={(e) => {
            const newValue = e.target.value;
            setQuery(newValue);
            if (newValue.length >= 2) setIsOpen(true);
            else setIsOpen(false);
          }}
          onFocus={() => query.length >= 2 && setIsOpen(true)}
          style={{
            width: "100%",
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            marginBottom: 0,
            marginLeft: '20px',
            fontWeight: "bold",
            textAlign: "center",
            fontSize: "16px",
          }}
        />

        <AnimatePresence>
          {isOpen && (
            <motion.ul
              className="process-options-list"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.2 }}
              style={{ width: "300px" }}
            >
              {filteredCodes.length > 0 ? (
                filteredCodes.map((option) => (
                  <li
                    key={option.value}
                    className="select-option"
                    onClick={() => {
                      onChange(option.value);
                      setQuery(option.value);
                      setIsOpen(false);
                    }}
                  >
                    <strong>{option.label}</strong>
                  </li>
                ))
              ) : (
                <li className="select-option disabled">No matches</li> // 👈 keep open but show "no matches"
              )}
            </motion.ul>
          )}
        </AnimatePresence>
      </div>
    );
  };

  const validateForm = (merged) => {
    const requiredFields = [
      "CustomerCode",
      "ShippingAddressLine1",
      "ShippingCity",
      "ShippingState",
      "ShippingZip",
      "TaxCode",
      "BranchCode",
      "Territory"
    ];
    const missing = [];
    requiredFields.forEach((field) => {
      const value = merged[field];
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "")
      ) {
        missing.push(field);
      }
    });
    return missing;
  }

  useEffect(() => {
    const fetchTerritoryAndBranchCodes = async () => {
      try {
        const res = await axios.post("/api/getcodes"); // 👈 POST request
        const data = res.data; // axios automatically parses JSON

        setBranchCodes(data.branchCodes);
        setTerritoryCodes(data.territoryCodes);
        setTaxCodes(data.taxCodes);
      } catch (err) {
        console.error("❌ Error fetching codes:", err.message);
      }
    };

    fetchTerritoryAndBranchCodes();
  }, []);

  // progress creep
  useEffect(() => {
    if (customerLoading) {
      // Reset when starting
      setProgress(0);

      progressRef.current = setInterval(() => {
        setProgress(prev => {
          // stutter increments: 1–5% jumps
          const increment = Math.floor(Math.random() * 5) + 1;
          const next = prev + increment;

          // stop creeping around ~90% max
          return next >= 90 ? 90 : next;
        });
      }, 800); // every ~0.8s

      return () => clearInterval(progressRef.current);
    } else {
      clearInterval(progressRef.current);
    }
  }, [customerLoading]);

  const handleRetrieve = () => {
    if (!customerCodeRequest) return;
    setCustomerLoading(true);
    setIsRetrieveLoading(true);

    axios.post(getCustomer, { customerCodeRequest })
      .then(response => {
        console.log('Customer profile fetched successfully:', response.data);
        const taxCode = response.data.TaxCode ? response.data.TaxCode.slice(-6) : '';
        setCustomer({
          ...response.data,
          TaxCode: taxCode
        });
      })
      .catch(error => {
        console.error('Error fetching customer profile:', error);
      })
      .finally(() => {
        setCustomerLoading(false);
        setIsRetrieveLoading(false);
      });
  };


  // Treat empty strings and whitespace as "blank"
  const isBlank = (v) =>
    v === undefined || v === null || (typeof v === "string" && v.trim() === "");

  // Merge that only applies non-blank new values
  const mergePreferNewIfMeaningful = (oldObj, patchObj) => {
    const out = { ...oldObj };
    for (const [k, v] of Object.entries(patchObj || {})) {
      if (!isBlank(v)) out[k] = v; // only overwrite if meaningful
    }
    return out;
  };

  // If backend supports partial updates, send only changed + meaningful fields:
  const diffMeaningful = (oldObj, patchObj) => {
    const diff = {};
    for (const [k, v] of Object.entries(patchObj || {})) {
      if (!isBlank(v) && v !== oldObj[k]) diff[k] = v;
    }
    return diff;
  };

  // (Optional) standardize codes/ZIP before submit
  const toUpperIf = (v) => (typeof v === "string" ? v.toUpperCase() : v);
  const onlyDigits = (v = "") => v.replace(/\D/g, "");



  const handleSubmit = (e) => {
    e.preventDefault();

    const merged = mergePreferNewIfMeaningful(customer, newCustomer);

    const missingFields = validateForm(merged);
    if (missingFields.length > 0) {
      const errorList = (
        <ul style={{ margin: 0, paddingLeft: "1.2rem" }}>
          {missingFields.map(field => (
            <li key={field}>{field}</li>
          ))}
        </ul>
      );

      setIsReviewing(false);

      setToast({
        type: "error",
        message: (
          <div
            className="custom-scroll"
            style={{
              display: "flex",
              flexDirection: "column",
              textAlign: "left",
              justifyContent: "flex-start",
              maxHeight: "400px",          // cap height
              overflowY: "auto",           // scroll if needed
              width: "100%",               // take full width of toast
            }}
          >
            <h2 style={{ margin: "0 0 0.5rem 0", fontWeight: "bold" }}>
              Missing Required Fields
            </h2>
            <p style={{ margin: "0 0 0.5rem 0", fontWeight: "lighter" }}>
              Sandy, you forgot:
            </p>
            <div
            >
              {errorList}
            </div>
          </div>
        ),
      });
      setTimeout(() => {
        setToast({ type: "", message: "" });
      }, 7000);

      return;
    } else {
      setIsReviewing(true);
    }

  };

  const handleCodeCheck = async () => {
    if (!newCustomer.CustomerCode) return;
    setIsCheckLoading(true);
    setStatus(null);

    try {
      const response = await axios.post("/api/customercodecheck", {
        customerCode: newCustomer.CustomerCode.toUpperCase()
      });

      if (response.data.exists) {
        setStatus("❌ In Use");
      } else {
        setStatus("✅ Available");
      }
    } catch (error) {
      console.error("Error checking code:", error);
      setStatus("⚠️ Error checking code.");
    } finally {
      setIsCheckLoading(false);
    }
  };

  const handleModalSubmit = async (e) => {
    if (e) e.preventDefault();
    setIsReviewing(false);
    setIsLoading(true);

    const merged = mergePreferNewIfMeaningful(customer, newCustomer);

    const payload = {
      ...merged,
      CustomerCode: toUpperIf(merged.CustomerCode),
      ShippingState: toUpperIf(merged.ShippingState),
      BranchCode: toUpperIf(merged.BranchCode),
      Territory: toUpperIf(merged.Territory),
      ShippingZip: onlyDigits(merged.ShippingZip).slice(0, 5),
      Salesperson: "000000"
    }

    try {
      const response = await axios.post(accountCopy,
        payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      console.log('Customer created successfully:', response.data);
      setProgress(100); // set progress to 100% on success

      setTimeout(() => {
        setToast({ type: 'success', message: response.data.message });
      }, 1000);

      setTimeout(() => {
        setProgress(0);
      }, 1500);

      setTimeout(() => {
        setToast({ type: '', message: '' });
      }, 7000);
    } catch (error) {
      console.error('Error creating customer:', error);
    } finally {
      // toast to timeout after 7 seconds

      setProgress(0);
      // reset loading state
      setIsLoading(false);
      // reset form
      setCustomer({
        CustomerCode: '',
        ShippingLastName: '',
        TaxCode: '',
        BranchCode: '',
        Territory: '',
        ShippingAddressLine1: '',
        ShippingAddressLine2: '',
        CollateFormEmailOverride: '',
        ShippingCity: '',
        ShippingState: '',
        ShippingZip: ''
      });
      setNewCustomer({
        CustomerCode: '',
        TaxCode: '',
        BranchCode: '',
        Territory: '',
        ShippingAddressLine1: '',
        ShippingAddressLine2: '',
        CollateFormEmailOverride: '',
        ShippingCity: '',
        ShippingState: '',
        ShippingZip: ''
      });
      setStatus(null);

    }
  };


  return (
    <div style={{ marginTop: '-2rem', padding: '2rem', textAlign: 'center', width: '80vw', margin: '0 auto' }}>
      <p style={{ fontSize: '2rem', fontWeight: 'bold', color: '#00767aff', marginBottom: '2rem', textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)' }}>{greeting()} Sandy!</p>

      <div className="form-div-top">
        <section className='header-section'>
          <button onClick={() => navigate('/')} className='header-button'>⬅ Back to Dashboard</button>
          <h2 >Account Copy  Form</h2>
        </section>
        <form onSubmit={(e) => e.preventDefault()} noValidate>
          <div style={{ marginTop: '1rem' }}>

            <section style={{ textAlign: 'center', marginTop: '1rem' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <label htmlFor='customerCodeRequest' style={{ fontWeight: 'bold', fontSize: '18px' }}>
                  <input type="text" id="customerCodeRequest" name="customerCodeRequest" placeholder="Customer Code" value={customerCodeRequest} onChange={(e) => setCustomerCodeRequest(e.target.value)} style={{ width: '140px', fontSize: '16px', fontWeight: 'bold', textAlign: 'center', borderRadius: '4px' }} />
                </label>
                <button onClick={handleRetrieve}
                  style={{
                    border: "none",
                    borderRadius: "4px",  // round only right corners
                    background: "#058516ff",
                    color: "#ffffffff",
                    padding: "12px 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "60px",
                    cursor: "pointer",
                    marginTop: ".1rem"
                  }}
                >
                  {isRetrieveLoading ? <div className="spinner" /> : "Retrieve"}</button>
              </div>
            </section>
          </div>
          <div style={{ marginTop: '1rem', minHeight: '24px' }}>
            {isLoading ? (
              <div style={{ width: '100%', maxWidth: '200px', height: '6px', backgroundColor: '#e0e0e0', borderRadius: '3px', overflow: 'hidden', margin: '0 auto' }}>
                <ProgressBar progress={retrieveProgress} text="Loading Customer..." />
              </div>
            ) : (
              <p><strong style={{ color: 'green', fontSize: '18px' }}>{customer.ShippingLastName}</strong></p>
            )}
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <section className='copy-form-section'>
              <div style={{ textAlign: 'left' }}>

                <div className="field-row">
                  <span className="field-label">Customer Code:</span>
                  <span className="field-old">{customer.CustomerCode}</span>
                  <span className="field-arrow">→</span>
                  <div className="field-new-taxes">
                    <span style={{ color: status === "✅ Available" ? "green" : "red" }}>{status}</span>
                    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                      <input
                        name="customerCode"
                        type="text"
                        value={newCustomer.CustomerCode.toUpperCase()}
                        onChange={(e) =>
                          setNewCustomer({ ...newCustomer, CustomerCode: toUpperIf(e.target.value) })
                        }
                        style={{
                          flex: 1,
                          border: "1px solid #ccc",
                          borderRight: "none",          // remove right border so it connects
                          borderRadius: "4px 0 0 4px", // round only left corners
                          padding: "6px 8px"
                        }}
                      />
                      <button
                        type="button"
                        onClick={handleCodeCheck}
                        style={{
                          border: "1.5px solid #ccc",
                          borderRadius: "0 4px 4px 0",  // round only right corners
                          background: "#1582caff",
                          color: "#ffffffff",
                          padding: "6px 12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          minWidth: "60px",
                          cursor: "pointer",
                          marginTop: "-17px"
                        }}
                      >
                        {isCheckLoading ? <div className="spinner" /> : "Check"}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="field-row">
                  <span className="field-label">Shipping Address:</span>
                  <span className="field-old">{customer.ShippingAddressLine1}</span>
                  <span className="field-arrow">→</span>
                  <div className="field-new">
                    <input type="text" value={newCustomer.ShippingAddressLine1} placeholder="Shipping Address (unchanged)" onChange={(e) => setNewCustomer({ ...newCustomer, ShippingAddressLine1: e.target.value })} />
                  </div>
                </div>

                <div className="field-row">
                  <span className="field-label">Shipping Address2:</span>
                  <span className="field-old">{customer.ShippingAddressLine2}</span>
                  <span className="field-arrow">→</span>
                  <div className="field-new">
                    <input type="text" value={newCustomer.ShippingAddressLine2} placeholder="Shipping Address 2 (unchanged)" onChange={(e) => setNewCustomer({ ...newCustomer, ShippingAddressLine2: e.target.value })} />
                  </div>
                </div>

                <div className="field-row">
                  <span className="field-label">Email:</span>
                  <span className="field-old">{customer.CollateFormEmailOverride}</span>
                  <span className="field-arrow">→</span>
                  <div className="field-new">
                    <input type="text" value={newCustomer.CollateFormEmailOverride} placeholder="Email (unchanged)" onChange={(e) => setNewCustomer({ ...newCustomer, CollateFormEmailOverride: e.target.value })} />
                  </div>
                </div>

                <div className="field-row">
                  <span className="field-label">City:</span>
                  <span className="field-old">{customer.ShippingCity}</span>
                  <span className="field-arrow">→</span>
                  <div className="field-new">
                    <input type="text" value={newCustomer.ShippingCity} placeholder="City (unchanged)" onChange={(e) => setNewCustomer({ ...newCustomer, ShippingCity: e.target.value })} />
                  </div>
                </div>
                <div className="field-row">
                  <span className="field-label">Zip:</span>
                  <span className="field-old">{customer.ShippingZip}</span>
                  <span className="field-arrow">→</span>
                  <div className="field-new">
                    <input type="text" inputMode="numeric" pattern="\d{5}" maxLength={5} placeholder="ZIP Code (unchanged)" value={newCustomer.ShippingZip} onChange={(e) => { const val = onlyDigits(e.target.value).slice(0, 5); setNewCustomer({ ...newCustomer, ShippingZip: val }) }} />
                  </div>
                </div>

                <div className="field-row">
                  <span className="field-label">State:</span>
                  <span className="field-old">{customer.ShippingState}</span>
                  <span className="field-arrow">→</span>
                  <div className="field-new">
                    <CustomSelect
                      label=""  /* hide label inside */
                      value={newCustomer.ShippingState}
                      onChange={(val) => setNewCustomer({ ...newCustomer, ShippingState: val })}
                      options={states}
                    />
                  </div>
                </div>

                <div className="field-row">
                  <span className="field-label">Branch:</span>
                  <span className="field-old">{customer.BranchCode}</span>
                  <span className="field-arrow">→</span>
                  <div className="field-new">
                    <CustomSelect
                      label=""
                      value={newCustomer.BranchCode}
                      onChange={(val) =>
                        setNewCustomer({ ...newCustomer, BranchCode: val })
                      }
                      options={branchCodes}
                    />
                  </div>
                </div>

                <div className="field-row">
                  <span className="field-label">Territory:</span>
                  <span className="field-old">{customer.Territory}</span>
                  <span className="field-arrow">→</span>
                  <div className="field-new">
                    <CustomSelect
                      label=""
                      value={newCustomer.Territory}
                      onChange={(val) =>
                        setNewCustomer({ ...newCustomer, Territory: val })
                      }
                      options={territoryCodes}
                    />
                  </div>
                </div>

                <div className="field-row">
                  <span className="field-label">Tax Code:</span>
                  <span className="field-old">{customer.TaxCode}</span>
                  <span className="field-arrow">→</span>
                  <div className="field-new">
                    <TaxCodeSelect label="" value={newCustomer.TaxCode} onChange={(val) => setNewCustomer((prev) => ({ ...prev, TaxCode: val }))} taxCodes={taxCodes} />
                  </div>
                </div>

              </div>
            </section>
          </div>

          <div style={{ marginTop: '1rem' }}>
            <button type="submit" style={{ padding: '0.8rem 1rem', fontWeight: 'bold', fontSize: '1rem', backgroundColor: '#2A3990', color: '#fff', border: 'none', borderRadius: '4px' }} onClick={handleSubmit}>
              Copy Customer
            </button>
          </div>

          {isReviewing && !isLoading && (
            <div className="review-section">
              <div className="modal-backdrop">
                <div className="process-modal">
                  <h3>Review Your Request</h3>
                  <p><strong>New Customer Copy</strong></p>
                  <ul className="review-list">
                    <li><strong>Customer Code:</strong> {newCustomer.CustomerCode}</li>
                    <li><strong>Shipping Address:</strong> {newCustomer.ShippingAddressLine1}</li>
                    <li><strong>Shipping Address2:</strong> {newCustomer.ShippingAddressLine2}</li>
                    <li><strong>Email:</strong> {newCustomer.CollateFormEmailOverride}</li>
                    <li><strong>Shipping City:</strong> {newCustomer.ShippingCity}</li>
                    <li><strong>Shipping State:</strong> {newCustomer.ShippingState}</li>
                    <li><strong>Shipping Zip:</strong> {newCustomer.ShippingZip}</li>
                    <li><strong>Tax Code:</strong> {newCustomer.TaxCode}</li>
                    <li><strong>Branch:</strong> {newCustomer.BranchCode}</li>
                    <li><strong>Territory:</strong> {newCustomer.Territory}</li>
                  </ul>
                  <div className="modal-actions">
                    <button className="cancel-button" onClick={() => setIsReviewing(false)}>Cancel</button>
                    <button className="confirm-button" onClick={handleModalSubmit}>Confirm</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isLoading && (
            <div className="review-section">
              <div className="modal-backdrop">
                <div className="process-modal">
                  <ProgressBar progress={progress} text="Copying customer..." />
                  <p>Hold tight Sandy, this takes a minute or two!</p>
                </div>
              </div>
            </div>
          )}


          {toast.message && (
            <div className={`toast ${toast.type}`}>
              {toast.message}
            </div>
          )}


        </form>

      </div>
    </div>
  );
};

export default CopyCustomerPage;


